import styled, { css } from "styled-components";
import React, { CSSProperties } from "react";
import { ExternalAccountType } from "@shared/types";
import { Discord, Telegram } from "common/Icons/Icons";

interface AccountTypeSelectorProps {
  accountType?: ExternalAccountType;
  setAccountType: (accountType: ExternalAccountType) => void;
  style?: CSSProperties;
}

const AccountTypeButtons = ({
  accountType,
  setAccountType,
  style,
}: AccountTypeSelectorProps) => {
  return (
    <Wrapper style={style}>
      <AccountTypeButton
        name="Telegram"
        icon={<StyledTelegram />}
        onClick={() => setAccountType(ExternalAccountType.TELEGRAM)}
        isSelected={accountType === ExternalAccountType.TELEGRAM}
      />
      <AccountTypeButton
        name="Discord"
        icon={<StyledDiscord />}
        onClick={() => setAccountType(ExternalAccountType.DISCORD)}
        isSelected={accountType === ExternalAccountType.DISCORD}
      />
    </Wrapper>
  );
};

export default AccountTypeButtons;

const Wrapper = styled.div`
  display: flex;
  column-gap: 8px;
`;
const iconStyles = css`
  margin-right: 8px;
`;
const StyledTelegram = styled(Telegram)`
  ${iconStyles}
`;
const StyledDiscord = styled(Discord)`
  ${iconStyles}
`;

interface AccountTypeButtonProps {
  name: string;
  icon: React.JSX.Element;
  onClick: () => void;
  isSelected: boolean;
  style?: CSSProperties;
}

export const AccountTypeButton = ({
  name,
  icon,
  onClick,
  isSelected,
  style,
}: AccountTypeButtonProps) => {
  return (
    <ButtonWrapper onClick={onClick} $isSelected={isSelected} style={style}>
      {icon}
      {name}
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div<{ $isSelected: boolean }>`
  flex: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: pointer;
  user-select: none;
  border-radius: 8px;
  transition: border 0.15s ease-in-out;
  border: ${(p) => p.theme.borders.medium};
  fill: ${(p) => p.theme.colors.secondaryText};
  color: ${(p) => p.theme.colors.secondaryText};
  font-weight: ${(p) => p.theme.typography.fontWeights.MEDIUM};

  ${(p) =>
    p.$isSelected &&
    `
    border: 1px solid ${p.theme.colors.primaryBlue};
    fill: ${p.theme.colors.primaryBlue};
    color: ${p.theme.colors.primaryBlue};
    `};
  &:hover {
    border: 1px solid ${(p) => p.theme.colors.primaryBlue};
    fill: ${(p) => p.theme.colors.primaryBlue};
    color: ${(p) => p.theme.colors.primaryBlue};
  }
`;
